module.exports = __webpack_public_path__ + "img/red-other-bg.cb3d9a5a.png";